/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Logout1Inputs */

const en_common_logout1 = /** @type {(inputs: Common_Logout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log out`)
};

/**
* | output |
* | --- |
* | "Log out" |
*
* @param {Common_Logout1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_logout1 = /** @type {((inputs?: Common_Logout1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Logout1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_logout1(inputs)
});
export { common_logout1 as "common_logOut" }